<div class="d-flex gap-3" role="radiogroup">
  <div
    class="form-check form-check-inline"
    *ngFor="let item of items; trackBy: trackByLookupId">
    <input
      class="form-check-input"
      type="radio"
      [id]="idPrefix + '-' + item.id"
      [disabled]="isDisabled"
      [checked]="value === item.id"
      (change)="onRadioChange(item.id)" />
    <label
      class="form-check-label"
      [for]="idPrefix + '-' + item.id">
      {{ 'GenericLookup::' + item.code | abpLocalization }}
    </label>
  </div>
</div>
